export default "__VITE_ASSET__CMdJHdY2__"